


















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class InstantMatchProgressItem extends Vue {
  @Prop({ type: Number }) readonly number!: number
  @Prop({ type: String }) readonly text!: string
  @Prop({ type: Number }) readonly step!: number

  @Watch('active')
  onActiveChanged() {
    this.expanded = true
  }

  expanded: boolean = true

  get active() {
    // eslint-disable-next-line eqeqeq
    return this.step == this.number
  }

  get completed() {
    return this.step > this.number
  }

  onButtonClick() {
    this.expanded = !this.expanded
  }
}
